import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { Box, Button, CircularProgress, IconButton, MenuItem, Select, TextField, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { RootState, useAppDispatch, useAppSelector } from '../../../../../state/state';
import { closeModal, toggleLoading } from '../../../../../state/ModalSlice/ModalSlice';
import { toast } from 'react-toastify';
import { addDoc, collection } from 'firebase/firestore';
import { db } from '../../../../../Config/firebase';

type Props = {
  boardId: string | null;
};

export default function AddColumnModal({ boardId }: Props) {
  const open = useAppSelector((state: RootState) => state.ModalSlice.AddColumnModalOpen);
  const isLoading = useAppSelector((state: RootState) => state.ModalSlice.isLoading);
  const user = useAppSelector((state: RootState) => state.userSliceV2.data);
  const userId = user?.uid || '';
  const dispatch = useAppDispatch();

  const [title, setTitle] = useState('');
  const [index, setIndex] = useState<number>(0);

  const handleClose = () => {
    dispatch(closeModal('AddColumnModalOpen'));
    setTitle('');
    setIndex(0);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!userId || !boardId) {
      toast.error('Missing user or board');
      return;
    }
    if (!title.trim()) {
      toast.error('Column title is required');
      return;
    }
    try {
      dispatch(toggleLoading(true));
      const colRef = collection(db, `ServiceProviders/${userId}/InflowBoards/${boardId}/Columns`);
      await addDoc(colRef, { title: title.trim(), index, createdAt: Date.now() });
      toast.success('Column added');
      handleClose();
    } catch (e) {
      console.error(e);
      toast.error('Failed to add column');
    } finally {
      dispatch(toggleLoading(false));
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 2, borderBottom: '1px solid rgba(0,0,0,0.12)' }}>
        <Typography variant="h6">Add Column</Typography>
        <IconButton onClick={handleClose} size="small"><CloseIcon /></IconButton>
      </Box>
      <DialogContent>
        <Box component="form" onSubmit={handleSubmit}>
          <TextField fullWidth label="Title" value={title} onChange={(e) => setTitle(e.target.value)} disabled={isLoading} />
          <TextField type="number" fullWidth label="Index" value={index} onChange={(e) => setIndex(Number(e.target.value))} disabled={isLoading} sx={{ mt: 2 }} />
          <Button type="submit" variant="contained" sx={{ mt: 2 }} fullWidth disabled={isLoading} startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : null}>Add</Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}


